const n = "_detailRowContainer_1dnpl_1", a = "_detailContainer_1dnpl_6", t = "_isWrapping_1dnpl_13", e = "_valueContainer_1dnpl_17", i = "_iconContainer_1dnpl_27", o = "_labelContainer_1dnpl_37", l = {
  detailRowContainer: n,
  detailContainer: a,
  isWrapping: t,
  valueContainer: e,
  iconContainer: i,
  labelContainer: o
};
export {
  l as default,
  a as detailContainer,
  n as detailRowContainer,
  i as iconContainer,
  t as isWrapping,
  o as labelContainer,
  e as valueContainer
};
//# sourceMappingURL=index.es5479.js.map
